import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/shadcn/empty";
import { getErrorMessage } from "@/components/utils/errorUtils";
import { useTranslation } from "react-i18next";

import { TbError404 } from "react-icons/tb";

export default function ErrorDisplay({
  title,
  message,
  error,
  cta = null,
  icon = <TbError404 />,
}: {
  cta?: React.ReactNode;
  icon?: React.ReactNode;
  title?: string;
  message?: string;
  error?: Error | null;
}) {
  const { t } = useTranslation(["shell", "common"]);
  // Extract message from error if provided
  const displayMessage =
    message || getErrorMessage(error, t("errorDisplay.fallbackMessage"));

  const displayTitle = title || t("errorDisplay.fallbackTitle");

  return (
    <div className="h-full w-full flex items-center">
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">{icon}</EmptyMedia>
          <EmptyTitle>{displayTitle}</EmptyTitle>
          <EmptyDescription className="text-base">
            {displayMessage}
          </EmptyDescription>
        </EmptyHeader>
        <EmptyContent>{cta}</EmptyContent>
      </Empty>
    </div>
  );
}
